import { Injectable } from "@angular/core";
import { PagingParams } from "@app/_models/paged";
import { Action, State, StateContext } from "@ngxs/store";
import { ListComponentStateInitial, SetSearchFormState } from "./list-component.actions";


export interface ListComponentStateItem {
    form: any,
    pagingParams: PagingParams
}

export interface ListComponentStateModel {
    additionalDataBuilding?: ListComponentState;
    additionalDataEstate?: ListComponentState;
    additionalDataSpace?: ListComponentState;
    assignment?: ListComponentState;
    assignmentTemplate?: ListComponentState;
    buildingStandardTerm?: ListComponentState;
    company?: ListComponentState;
    costCentre?: ListComponentState;
    estate?: ListComponentState;
    maintenanceBook?: ListComponentState;
    moveNotification?: ListComponentState;
    notificationReceived?: ListComponentState;
    notificationSent?: ListComponentState;
    ownAssignment?: ListComponentState;
    permissions?: ListComponentState;
    person?: ListComponentState;
    projects?: ListComponentState;
    publicationRelease?: ListComponentState;
    user?: ListComponentState;
    workTimeRecords?: ListComponentState
}

const defaults: ListComponentStateModel = {
    additionalDataBuilding: null,
    additionalDataEstate: null,
    additionalDataSpace: null,
    assignment: null,
    assignmentTemplate: null,
    buildingStandardTerm: null,
    company: null,
    costCentre: null,
    estate: null,
    maintenanceBook: null,
    moveNotification: null,
    notificationReceived: null,
    notificationSent: null,
    ownAssignment: null,
    permissions: null,
    person: null,
    projects: null,
    publicationRelease: null,
    user: null,
    workTimeRecords: null
};

@State<ListComponentStateModel>({
    name: 'listComponentState',
    defaults: defaults
})

@Injectable()
export class ListComponentState {

    constructor() { }

    @Action(SetSearchFormState) setSearchFormState(ctx: StateContext<ListComponentStateModel>, action: SetSearchFormState) {
        const state = ctx.getState();
        ctx.setState({ ...state, [action.key]: action.payload });
    }

    @Action(ListComponentStateInitial) listComponentStateInitial(ctx: StateContext<ListComponentStateModel>) {
        ctx.setState({ ...defaults });
    }

}